export const CheckmarkSvg = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.2l-4.2-4.2a1 1 0 10-1.4 1.4l5 5c.4.4 1 .4 1.4 0l10-10a1 1 0 00-1.4-1.4L9 16.2z"
        fill="#4CAF50"
      />
    </svg>
  );